<template>
  <van-tabbar route active-color="rgb(160, 96, 152)" inactive-color="rgb(200, 174, 217)">
    <van-tabbar-item replace to="/">
      <span>{{ $t("footer.home") }}</span>
      <template #icon>
        <img :src="$route.name == 'home' ? homeac : home" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/gallery" style="display: none;">
      <span>{{ $t("footer.gallery") }}</span>
      <template #icon>
        <img :src="$route.name == 'gallery' ? foot2ac : foot2" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/match">
      <span>{{ $t("footer.match") }}</span>
      <template #icon>
        <img :src="$route.name == 'match' ? foot3ac : foot3" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/verification">
      <span>{{ $t("footer.verification") }}</span>
      <template #icon>
        <img :src="$route.name == 'verification' ? foot4ac : foot4" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/mine">
      <span>{{ $t("footer.mine") }}</span>
      <template #icon>
        <img :src="$route.name == 'mine' ? mineac : mine" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: "FooterView",
  data() {
    return {
      home: require("@/assets/img/footer/home.png"),
      homeac: require("@/assets/img/footer/home-active.png"),
      foot2: require("@/assets/img/footer/foot2.png"),
      foot2ac: require("@/assets/img/footer/foot2-active.png"),
      foot3: require("@/assets/img/footer/foot3.png"),
      foot3ac: require("@/assets/img/footer/foot3-active.png"),
      foot4: require("@/assets/img/footer/foot4.png"),
      foot4ac: require("@/assets/img/footer/foot4-active.png"),
      mine: require("@/assets/img/footer/mine.png"),
      mineac: require("@/assets/img/footer/mine-active.png"),
    };
  },
};
</script>

<style></style>
